import { connect } from 'react-redux';
import SeatingplanView from './SeatingplanView.jsx';

const mapStateToProps = (state) => ({
	name: state.seatingplan.name,
});


const mapDispatchToProps = () => ({
});

const Seatingplan = connect(
	mapStateToProps,
	mapDispatchToProps
)(SeatingplanView);

export default Seatingplan;
